import axios from 'axios';
import { ThunkDispatch } from 'redux-thunk';

import Creators from './actions';
import parseChargeBackIssueTypes from './selectors';
import ReduxStore from 'src/types/store/reduxStore';

export const { clearIssueTypes, receiveIssueTypes } = Creators;

export const fetchChargeBackIssueTypes =
  () => async (dispatch: ThunkDispatch<ReduxStore, void, any>, getState: () => ReduxStore) => {
    const appName = getState().app.apiAppName;

    const request = [
      {
        name: `${appName}-chargebackIssueTypes`,
        pageNumber: 1,
        pageSize: 20,
        doAggregation: false,
        returnDocuments: true,
        searchBy: 'parent',
        searchType: `${appName}-chargebackIssueTypes`,
        aggregations: null
      }
    ];

    const response = await axios.post(`/api/${appName}/AdvancedSearch?_id=fetchChargeBackIssueTypes`, request);
    dispatch(receiveIssueTypes(parseChargeBackIssueTypes(response)));
  };
